import { render } from "./bananer.vue?vue&type=template&id=88690cd6&scoped=true"
import script from "./bananer.vue?vue&type=script&lang=js"
export * from "./bananer.vue?vue&type=script&lang=js"

import "./bananer.vue?vue&type=style&index=0&id=88690cd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88690cd6"]])

export default __exports__